import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { MeUser } from '@app/security/data-access/user/user.types';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthHttpService {
  private http = inject(HttpClient);

  fetchUserDetails(): Observable<MeUser> {
    return this.http.get<MeUser>(`${environment.apiUrl}/api/me`);
  }
}
